const UNAUTHENTICATED_PATHS = [
  '/login',
  '/recover_password/',
  '/login/forgot_password/',
  '/saved_report/',
  '/dashboard/devices',
  '/view_all_shifts/',
  '/view_defect_by_description/',
  '/unauthorized',
  '/reset_training',
  '/design',
  '/home',
  '/login/mobile_auth'
]

function isUnauthenticatedPath(path) {
  for (let p of UNAUTHENTICATED_PATHS) {
    if (path.indexOf(p) !== -1) return true;
  }

  return false;
}

export default function ({ store, route, redirect }) {
  return store.dispatch('login/hasSession').then((response) => {
    let hasSession = response.data.status;

    //code written for auht0
    store.commit('login/setHasSessionStatus', hasSession)
    if (response.data.auth0) {
      let org_id = response.data.auth0_details.auth0_organisation;
      let client_id = response.data.auth0_details.auth0_spa_client_id;
      store.commit('login/setIsAuth0', response.data.auth0);
      store.commit('login/setOrganization', org_id);
      store.commit('login/setClientid', client_id)
    }
    //end
    if (!hasSession && store.getters["login/isLoggedIn"]) {
      if (store.getters['login/isAuthUser']) {
        store.dispatch("login/logout", { pathToSave: undefined })
      } else {
        store.commit('login/setShowLogin', true)
      }
    } else if (!store.getters["login/isLoggedIn"]) {
      if (hasSession) {
        return store.dispatch('login/restoreSession').catch(() => redirect("/login"));
      } else if (!isUnauthenticatedPath(route.path)) {
        store.dispatch('login/logout', { pathToSave: route.fullPath !== "/" ? route.fullPath : undefined })
      }
    }
  })

}